import CalendarItemWithSubscriptionParticipation from './CalendarItemWithSubscriptionParticipation';

export default {
    ...CalendarItemWithSubscriptionParticipation,
    name: CalendarItemWithSubscriptionParticipation.name + '_resource',
};
